/**
 * supabase.ts — the RACER ID backend (M100).
 *
 * These two values are PUBLIC BY DESIGN (they ship in every browser bundle,
 * like the worker wss URL in network.ts — NO secrets here): the publishable
 * key only ever grants what Row Level Security + the SECURITY DEFINER RPCs
 * allow, and every table in the project is locked to "read your own rows /
 * write through the server-side functions". The service-role key must NEVER
 * appear anywhere in this repo.
 *
 * Project: dribble-racer (us-east-1) — dashboard:
 * https://supabase.com/dashboard/project/wrhwnoaeyofkvmkcqagl
 *
 * KILL SWITCH: set SUPABASE_ENABLED to false and the whole account layer
 * disappears — awards flow exactly like pre-M100 (straight to the local
 * save), no network calls, no UI. One flag, instant rollback.
 */
// M100b: the CUSTOM AUTH DOMAIN (activated 2026-07-28) — sign-in emails and
// the Google/Apple hand-off wear dribbleracer.com instead of the project ref.
// The old https://wrhwnoaeyofkvmkcqagl.supabase.co endpoint keeps working, so
// this is a safe swap either direction.
// GOTCHA: supabase-js derives its session storage key from the URL's first
// hostname label ('sb-<label>-auth-token'), so changing this URL LOGS OUT any
// existing local session (it looks in a new key). Harmless at the M100b swap
// (nobody was signed in on the domain yet); if this URL ever changes again,
// expect every player to sign in once more.
export const SUPABASE_URL = 'https://auth.dribbleracer.com';
export const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_spDlYWN1bNog49onD_JaKg_ItnxHnyb';
export const SUPABASE_ENABLED = true;
